import { ListItem, styled } from '@mui/material';

const StyledAvailabilityStatusListItem = styled(ListItem)(() => ({
  width: 'auto'
}));

export default StyledAvailabilityStatusListItem;
